import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { closeModal } from 'reducers/modals';
// components
import Button from 'components/Button';
import { FormattedMessage } from 'react-intl';
// utils
import classNames from 'classnames/bind';
// styles
import styles from './OfflineSubmitAlert.module.scss';
import drBotImage from '../../../../../public/images/dr-bot.svg';
import { ReactComponent as NoConnectionIcon } from 'assets/svg/no-connection.svg';

const cn = classNames.bind(styles);

// illustration: Dr.Bot for checkups; a no-connection icon where the character is not wanted (Feed Orders, EPN-3082)
const OfflineSubmitAlert = ({ closeModal, messageId, illustration }) => (
  <div className={cn('offline-submit-alert')}>
    <div className={cn('offline-submit-body')}>
      {illustration === 'noConnection' ? (
        <div className={cn('offline-no-connection')}>
          <NoConnectionIcon />
        </div>
      ) : (
        <div className={cn('offline-bot-doc')}>
          <img className={cn('offline-bot-doc-image')} src={drBotImage} alt="" />
          <br />
          <FormattedMessage id="general.drBot">
            {(text) => <div className={cn('offline-bot-doc-name')}>{text}</div>}
          </FormattedMessage>
        </div>
      )}
      <FormattedMessage id={messageId}>
        {(text) => <div className={cn('offline-bot-message')}>{text}</div>}
      </FormattedMessage>
    </div>
    <Button className={cn('bottom-btn')} onClick={() => closeModal()} primary>
      <FormattedMessage id="general.button.gotIt" />
    </Button>
  </div>
);

OfflineSubmitAlert.defaultProps = {
  messageId: 'component.modal.offlineSubmitAlert.text',
  illustration: 'drBot',
};

OfflineSubmitAlert.propTypes = {
  closeModal: T.func.isRequired,
  messageId: T.string,
  illustration: T.oneOf(['drBot', 'noConnection']),
};

export default connect(null, { closeModal })(OfflineSubmitAlert);
